module.exports = __webpack_public_path__ + "static/media/Abu Dhabi Health Services Company (SEHA) 1.3777ece4.jpg";